import { render, staticRenderFns } from "./addResourceStoreType.vue?vue&type=template&id=0ecf980a&scoped=true"
import script from "./addResourceStoreType.vue?vue&type=script&lang=js"
export * from "./addResourceStoreType.vue?vue&type=script&lang=js"
import style0 from "./addResourceStoreType.vue?vue&type=style&index=0&id=0ecf980a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf980a",
  null
  
)

export default component.exports